import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { Button } from "antd";
import { DownloadOutlined, EyeOutlined } from "@ant-design/icons";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const AttendanceViewCard = ({ data, total, button }) => {
  const history = useHistory();
  const totalPresent = data?.users?.length | 0;
  const totalAbsent = total - totalPresent | 0;

  const attendanceData = useMemo(() => {
    if (data && data?.users?.length) {
      return data?.users.map((a, i) => {
        return {
          ...a,
          key: i + 1,
        };
      });
    }
    return [];
  }, [data]);

  function generate() {
    const doc = new jsPDF();
    autoTable(doc, {
      body: [
        [
          {
            content: "Shreeji",
            styles: { halign: "left", fillColor: "fff" },
          },
          {
            content: "Jay Swaminarayan",
            styles: { halign: "center", fillColor: "fff" },
          },
          {
            content: "  bapa",
            styles: { halign: "right", fillColor: "fff" },
          },
        ],
      ],
    });

    autoTable(doc, {
      body: [
        [
          {
            content: `Date: ${data?.date}`,
            styles: { halign: "left", fillColor: "fff" },
          },
          {
            content: `Present: ${totalPresent} | Absent: ${totalAbsent}`,
            styles: { halign: "right", fillColor: "fff" },
          },
        ],
      ],
    });

    autoTable(doc, {
      head: [["No", "Name", "Contact"]],
      body: attendanceData.map((data, index) => {
        return [index + 1, data?.user_name, data?.mobile];
      }),
    });

    doc.save(`nikol-balmandal-${data?.date}.pdf`);
  }

  return (
    <AttendancecardStyle>
      <div className="flex space-between card">
        <div className="date-filed">Date: {data?.date}</div>
        <div className="flex gap-20 card-right">
          <div className="self-center flex-right">
            <div className="op7">Present</div>
            <div className="count">{totalPresent}</div>
          </div>
          <div className="self-center flex-right">
            <div className="op7">Absent</div>
            <div className="count">{totalAbsent}</div>
          </div>
          <div className="self-center">
            {button === "view" ? (
              <Button
                shape="round"
                icon={<EyeOutlined />}
                onClick={() =>
                  history.push(`/attendance/viewDetail/${data?._id}`)
                }
              >
                View
              </Button>
            ) : (
              <>
                <Button
                  className="btn-pdf"
                  shape="round"
                  icon={<DownloadOutlined />}
                  onClick={() => generate()}
                >
                  Download PDF
                </Button>
                <Button
                  className="btn-pdf-mobile"
                  shape="round"
                  icon={<DownloadOutlined />}
                  onClick={() => generate()}
                >
                  PDF
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </AttendancecardStyle>
  );
};

const AttendancecardStyle = styled.div`
  width: 100%;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.18) 0px 2px 4px;
  background: #203c72;
  font-family: "Cabin", sans-serif;
  color: white;
  margin-bottom: 20px;
  .flex {
    display: flex;
  }
  .space-between {
    justify-content: space-between;
  }
  .date-filed {
    padding: 25px;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.06em;
  }
  .self-center {
    align-self: center;
  }
  .ant-btn {
    margin-bottom: 0px;
    margin-right: 25px;
  }
  .gap-20 {
    gap: 20px;
  }
  .flex-right {
    font-size: 16px;
    letter-spacing: 0.05em;
    border-right: 1px solid rgb(215, 215, 222, 0.7);
    padding-right: 20px;
  }
  .op7 {
    opacity: 0.88;
  }
  .count {
    font-weight: 600;
    font-size: 17px;
  }
  .btn-pdf-mobile {
    display: none;
  }
  @media screen and (max-width: 520px) {
    .card {
      display: flex;
      flex-direction: column;
    }
    .card-right {
      margin: 0 0 12px 16px;
    }
    .date-filed {
      padding: 15px;
    }
    .btn-pdf {
      display: none;
    }
    .btn-pdf-mobile {
      display: block;
    }
  }
`;

export default AttendanceViewCard;
